<template>
  <div id="profile">
    <van-nav-bar
        title="个人信息"
        right-text="刷新"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
        @click-right="onClickRight"
    />
    <div class="personal-info">
      <van-cell
          title="头像"
          @click="editAvatar"
      >
        <template #right-icon>
          <van-image
              class="avatar"
              :src="avatar"
              fit="cover"
          />
        </template>
      </van-cell>
      <!-- 工号 -->
      <van-cell title="工号" :value="staff.code" />

      <!-- 名字 -->
      <van-cell title="名字" :value="staff.name" />

      <!-- 电话 -->
      <van-cell title="电话" :value="staff.phone" />

      <!-- 部门 -->
      <van-cell title="岗位" value="布尔洞" />

      <!-- 岗位 -->
      <van-cell title="岗位" :value="staff.deptName" />
    </div>
  </div>
</template>
<script>
import {Toast} from "vant";
import {mapState} from "vuex";

export default {
  data () {
    return {

    }
  },
  computed: {
    ...mapState('staff', ['staff']),
    ...mapState('token', ['token']),
    avatar () {
      return this.staff.avatar ? this.downloadApi + this.staff.avatar : require('@/assets/avatar.png')
    }
  },
  methods: {
    loading () {
    },
    beforeAvatarUpload(file) {
      // 验证图片类型和大小
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$toast('上传头像图片只能是 JPG 格式');
      }
      if (!isLt2M) {
        this.$toast('上传头像图片大小不能超过 2MB');
      }

      return isJPG && isLt2M;
    },
    editAvatar() {
      // 在这里处理编辑头像的逻辑，例如打开文件选择器
      // 你可以使用 Vant 的上传组件来实现
    },
    onClickLeft () {
      this.$router.go(-1);
    },
    onClickRight () {
      this.loading()
      Toast('已刷新');
    },
  },
  mounted () {
    this.loading()
  }
}
</script>
<style>
/* 样式可以根据需要进行自定义 */
.personal-info {
  padding: 16px;
}
.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%; /* 圆形头像 */
}
</style>